import ReactVisibilitySensor from "react-visibility-sensor"


const GallerySectionCol = ({ children } : { children : JSX.Element }) => {
  return (
    // <ReactVisibilitySensor
    //   partialVisibility
    // >
    //   {({isVisible} : any) => (
        <div className={`gallery-section-col an-move-top`}>
            {children}
        </div>
    //   )}
    // </ReactVisibilitySensor>
  )
}

// ${isVisible ? "an-active" : ""}

export default GallerySectionCol